// Generated by Typewriter / DataModelGenerator.tst
// https://frhagn.github.io/Typewriter/pages/documentation.html

import { CustomerTagDto } from './CustomerTagDto';
import { EntityBaseDto } from './EntityBaseDto';

// AbilityIntranet.Data.Intranet.CustomerTagGroupDto
export class CustomerTagGroupDto extends EntityBaseDto {
    public name: string = null;
    public displayOrder: number = 0;
    public tags: CustomerTagDto[] = [];
}


    



